import { login, getUserInfo } from '@/api/user'

const state = {
  token: localStorage.getItem('token') || '',
  userInfo: {},
  isLoggedIn: (!!localStorage.getItem('token'))
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    state.isLoggedIn = !!token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  CLEAR_USER(state) {
    // 清除 state 中的用户数据
    state.token = ''
    state.userInfo = {}
    state.isLoggedIn = false
    
    // 清除 localStorage 中的所有用户相关信息
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('loginTime')
    localStorage.removeItem('expireTime')
    
    // 可选：清除其他可能存在的用户相关数据
    // 例如购物车信息、浏览历史等
    // localStorage.removeItem('cartData')
    // localStorage.removeItem('browseHistory')
  }
}

const actions = {
  // 用户登录
  async login({ commit }, loginForm) {
    try {
      const response = await login(loginForm)
      const { token } = response.data
      commit('SET_TOKEN', token)
      return response
    } catch (error) {
      throw error
    }
  },

  // 获取用户信息
  async getUserInfo({ commit }) {
    try {
      const response = await getUserInfo()
      commit('SET_USER_INFO', response.data)
      return response
    } catch (error) {
      // throw error
     commit('CLEAR_USER')
      console.log('error')
    }
  },

  // 用户登出
  logout({ commit }) {
    commit('CLEAR_USER')
  }
}

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  userInfo: state => state.userInfo,
  token: state => state.token
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}